import ls from "../services/localStorage";
import { types } from "../constants/constants";

/**
 * @returns {Promise<{ bundle: Bundle }>}
 */
export const getApiBundle = async () => {
  const token = ls.get("token");

  const response = await fetch(`${types.API_URL}bundle`, {
    headers: { token: token ?? '' }
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result);
  } else {
    return result;
  }
};

/**
 * Get active bundles for listing
 * @param {Object} attributes - Query parameters (limit, offset, sortBy, sortDirection)
 * @returns {Promise<{ bundles: Bundle[], total: number }>}
 */
export const getApiBundles = (attributes) => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes) ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : '';
  const token = ls.get("token");

  return fetch(`${types.API_URL}bundles${query}`, {
    headers: { token: (token !== null ? token : '') },
  }).then(async (response) => {
    if (!response.ok) {
      const responseJson = await response.json();
      throw new Error(responseJson);
    }
    const result = await response.json();
    return result;
  });
};

export const getApiBundleBySlug = async (slug) => {
  const token = ls.get("token");
  const headers = {};

  // Solo enviar token si existe
  if (token) {
    headers.token = token;
  }

  const response = await fetch(`${types.API_URL}bundles/slug/${slug}`, {
    headers: headers
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result);
  } else {
    return result;
  }
};

export const postApiCreateBundleSale = async (attributes) => {
  const token = ls.get("token");

  const response = await fetch(`${types.API_URL}sale/bundle/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token ?? ''
    },
    body: JSON.stringify(attributes)
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result);
  } else {
    return result;
  }
};

/**
 * @typedef {Object} Bundle
 * @property {string} _id
 * @property {Course[]} courses
 * @property {string} description
 * @property {number} price
 * @property {string} title
 */

/**
 * @typedef {Object} Course
 * @property {string} _id
 * @property {string} content
 * @property {number} price
 * @property {string} title
 * @property {string} picture_big
 * @property {string} hours
 * @property {string} frequency
 */

/**
 * Subscribe email to newsletter via Brevo
 * @param {string} email - Email address to subscribe
 * @returns {Promise<{ message_status: string, message: string, email: string }>}
 */
export const postApiNewsletterSubscribe = async (email) => {
  const response = await fetch(
    `${types.API_URL}newsletter/subscribe`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    }
  );

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.error || result.message || "Error al suscribirse");
  }

  return result;
};
